import { useAuth } from "../contexts/AuthContext";

/**
 * Владелец: «все магазины / магазин / сотрудница».
 * Администратор магазина (me.view_store): «моя карточка / её магазин». Остальные сотрудницы видят только себя, селектора нет.
 */
export function ViewSelector() {
  const { me, t, view, setView, retail } = useAuth();
  if (!me) return null;
  if (!me.is_admin) {
    const vs = me.view_store;
    if (!vs) return null;
    const label = retail?.stores.find(s => s.store === vs)?.label ?? vs;
    return (
      <div className="px-5 py-2 bg-slate-50 border-b border-slate-200 flex items-center gap-2 text-xs flex-shrink-0">
        <label htmlFor="view-select" className="text-slate-600 font-medium shrink-0">{t("view_label")}</label>
        <select id="view-select" value={view} onChange={(e) => setView(e.target.value)} className="bg-white text-slate-900 rounded px-2 py-1 text-xs flex-1 border border-slate-300 min-w-0">
          <option value="all">{t("view_my_card")}</option>
          <option value={`store:${vs}`}>{t("view_store_prefix")} {label}</option>
        </select>
      </div>
    );
  }
  const stores = retail?.stores ?? [];
  const people = [...(retail?.rows ?? [])].sort((a, b) => (a.display_name ?? "").localeCompare(b.display_name ?? "", "ru"));
  return (
    <div className="px-5 py-2 bg-slate-50 border-b border-slate-200 flex items-center gap-2 text-xs flex-shrink-0">
      <label htmlFor="view-select" className="text-slate-600 font-medium shrink-0">{t("view_label")}</label>
      <select
        id="view-select"
        value={view}
        onChange={(e) => setView(e.target.value)}
        className="bg-white text-slate-900 rounded px-2 py-1 text-xs flex-1 border border-slate-300 min-w-0"
      >
        <option value="all">{t("view_all")}</option>
        {stores.map(s => <option key={s.store} value={`store:${s.store}`}>{t("view_store_prefix")} {s.label}</option>)}
        {people.map(r => <option key={r.person_id} value={`p:${r.person_id}`}>{r.display_name ?? r.person_id} · {r.store_label}</option>)}
      </select>
    </div>
  );
}
